import { useState } from "react";
import { useEffect } from "react";
import { AIR_FILTERED_CARDS_QUERY_CACHE_KEY, AIR_QUERY_CACHE_KEY } from "entities/AirSavedCard";

type UseAirQueryKeyProps = {
  isCurrentViewFilteredCards: boolean;
  isCurrentViewMain: boolean;
};

type UseAirQueryKeyReturnType = {
  queryKey: string;
};

export const useAirQueryKey = ({
  isCurrentViewFilteredCards,
  isCurrentViewMain,
}: UseAirQueryKeyProps): UseAirQueryKeyReturnType => {
  const [queryKey, setQueryKey] = useState<string>(AIR_FILTERED_CARDS_QUERY_CACHE_KEY);

  useEffect(() => {
    if (isCurrentViewFilteredCards) {
      setQueryKey(AIR_FILTERED_CARDS_QUERY_CACHE_KEY);
    }
    if (isCurrentViewMain) {
      setQueryKey(AIR_QUERY_CACHE_KEY);
    }
  }, [isCurrentViewFilteredCards, isCurrentViewMain]);

  return { queryKey };
};
